export const MESSAGE_INPUT_CSS = /* css */ `
  /* ── Chat input (horizontal: textarea left, toolbar right) ── */
  .lk-widget-input {
    display: flex; align-items: center;
    padding: 10px; background: var(--wg-bg-secondary);
    border-radius: 0 0 16px 16px; flex-shrink: 0;
    gap: 0;
  }
  .lk-widget-input textarea {
    flex: 1; min-width: 0;
    border: none; background: transparent;
    padding: 10px; font-size: 14px; font-family: inherit;
    color: var(--wg-fg); outline: none;
    resize: none; overflow-y: hidden;
    min-height: 25px; max-height: 123px;
    line-height: 1.5;
  }
  .lk-widget-input textarea::placeholder { color: var(--wg-card-fg-muted); }
  .lk-widget-input-toolbar {
    display: flex; align-items: center; flex-shrink: 0;
    gap: 5px;
  }

  /* Send button — disabled = --wg-send-disabled, enabled = --wg-send-active,
     hover adds a subtle teal drop shadow (--wg-send-glow). */
  .lk-widget-send-btn {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%; border: none;
    background: var(--wg-send-active); color: white; cursor: pointer;
    transition: background 0.15s ease, box-shadow 0.15s ease;
  }
  .lk-widget-send-btn svg { width: 13px; height: 13px; }
  .lk-widget-send-btn:disabled {
    background: var(--wg-send-disabled); cursor: default;
  }
  .lk-widget-send-btn:not(:disabled):hover {
    box-shadow: 0 0 2.143px var(--wg-send-glow), 0 0 8px rgba(38, 209, 151, 0.35);
  }

  /* Mobile: the input bar sits at the very bottom of a full-screen panel, so
     square off the bottom corners (they're rounded for the desktop card) and
     pad past the home-indicator / gesture bar via the safe-area inset — which
     also gives the grey bar a bit more height so the icons aren't jammed into
     the corner. env() is 0 on desktop, so this no-ops there. */
  @media (max-width: 768px) {
    .lk-widget-input {
      border-radius: 0;
      padding-bottom: calc(10px + env(safe-area-inset-bottom));
    }
    /* iOS Safari auto-zooms when you focus an input with font-size < 16px.
       Bump the composer to 16px on mobile to stop the zoom-on-focus; desktop
       keeps the 14px design. */
    .lk-widget-input textarea { font-size: 16px; }
  }
`;
